import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

const persist = new VuexPersistence({
  storage: window.localStorage,
  reducer: (state) => ({
    cgmUserVO: state.cgmUserVO
  }),
})

export default new Vuex.Store({
  state: {
    cgmUserVO: null,
    leftItem:1,
    mobile:false,
    nowcart: JSON.parse(sessionStorage.getItem("nowcart"))
  },
  mutations: {
    setCgmUserVO(state, item) {
      state.cgmUserVO = item
    },
    setLeftItem(state, item) {
      state.leftItem = item
    },
    setMobile(state, item) {
      state.mobile = item
    },
    setNowcart(state, item) {
      state.nowcart = item,
      sessionStorage.setItem("nowcart", JSON.stringify(item))
    },
    // setMlist(state, item) {
    //   state.mlist = item
    // },
  },
  actions: {
  },
  modules: {
  },
  plugins: [
    persist.plugin
  ]
})
